import { SITE_CONTACT } from '../data/siteData';
import { recordSystemNotification } from './notifications';
import { trackConversion } from './analytics';

export interface EmailPayload {
  subject: string;
  message: string;
  customerEmail: string;
  customerName: string;
  botTrap?: string;
  phone?: string;
  customerPhone?: string;
  amount?: number;
  service?: string;
  timestamp?: number;
}

export async function dispatchFormNotification(payload: EmailPayload): Promise<boolean> {
  const subLower = (payload.subject || '').toLowerCase();
  let notifType: 'form_submission' | 'hosting_order' | 'booking_request' | 'paybill_payment' = 'form_submission';

  if (subLower.includes('hosting') || subLower.includes('order') || subLower.includes('domain')) {
    notifType = 'hosting_order';
  } else if (subLower.includes('booking') || subLower.includes('strategy') || subLower.includes('diagnostic')) {
    notifType = 'booking_request';
  } else if (subLower.includes('paybill') || subLower.includes('payment')) {
    notifType = 'paybill_payment';
  }

  // 1. Record real-time notification for Admin Portal & trigger toast
  recordSystemNotification({
    type: notifType,
    title: payload.subject || 'New Website Submission',
    customerName: payload.customerName || 'Website Inquirer',
    customerEmail: payload.customerEmail || 'Not specified',
    customerPhone: payload.phone || payload.customerPhone,
    details: payload.message || 'New submission received from client',
    amount: payload.amount,
    service: payload.service,
  }).catch(() => {});

  // 2. Track actual conversion in GA4 and analytics
  trackConversion(
    'form_submission',
    payload.subject || 'Website Form Submission',
    payload.amount || 0,
    {
      subject: payload.subject,
      type: notifType,
    }
  );

  // 3. Silent server-side dispatch to /send_mail.php or /api/send-email
  try {
    const response = await fetch('/send_mail.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
      const data = await response.json().catch(() => null);
      if (data && data.success) {
        return true;
      }
    }
  } catch (err) {
    // Fail silently in development or purely static environments
  }

  // 4. Fallback attempt to Express /api/send-email proxy route
  try {
    const response = await fetch('/api/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
      return true;
    }
  } catch (err) {
    // Silent fail
  }

  return true;
}
